import axios from '@/libs/api.request'

export const foodTypePage = (info) => {
  return axios.request({
    url: 'foodType/page',
    data: info,
    method: 'post',
  })
}

export const foodTypeAdd = (info) => {
  return axios.request({
    url: 'foodType/add',
    data: info,
    method: 'post',
  })
}

export const foodTypeUpdate = (info) => {
  return axios.request({
    url: 'foodType/update',
    data: info,
    method: 'post',
  })
}

export const foodTypeDel = (info) => {
  return axios.request({
    url: 'foodType/del',
    data: info,
    method: 'post',
  })
}
